import React, { Dispatch, SetStateAction } from "react"
import { CalendarEntry } from "../../../backendServices/GraphQLServices"
import TextLimit from "../../TextLimit"
import { TextareaInput, TextareaWrapper } from "./CalendarEntryModal.styled"
import { CalendarEntryModalViewMode, onInputTextChangedNotes } from "./ModalFunctions"

interface PersonalNoteProps {
    placeholder: string
    setNote?: Dispatch<SetStateAction<string | undefined>>
    note?: string | undefined
    calendarEntry?: CalendarEntry
    viewMode?: CalendarEntryModalViewMode
    maxNoteLength?: number
}
const MAX_NOTES_LENGTH = 200

const TextareaPersonalNote = (props: PersonalNoteProps) => {
    const maxNoteLength = props.maxNoteLength ?? MAX_NOTES_LENGTH
    return (
        <TextareaWrapper>
            <TextareaInput
                placeholder={props.placeholder}
                value={props.note}
                onChange={(event) =>
                    props.viewMode === CalendarEntryModalViewMode.VIEW
                        ? undefined
                        : onInputTextChangedNotes(event, maxNoteLength, props.setNote!)
                }
            />
            <TextLimit
                position="absolute"
                bottom="5px"
                right="5px"
                textLength={props.note?.length || 0}
                maxTextLength={maxNoteLength}
            />
        </TextareaWrapper>
    )
}

export default TextareaPersonalNote
